import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThermometerHalf } from "@fortawesome/free-solid-svg-icons";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { faHandPointUp } from "@fortawesome/free-solid-svg-icons";
import api from "../../apis/EdisonApi";
import SubmitNetatmoData from "./SubmitNetatmoData";
import { toast } from "react-toastify";
import NetatmoChart from "./NetatmoChart";


const Netatmo = () => {
    const [status, setStatus] = useState('NA');

    useEffect(() => {
		const controller = new AbortController();
        getStatus();

		return () => {
			controller.abort();
		};
    }, []);

    const getStatus = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/netatmo/status', config);
            setStatus(resp.data.data);
        } catch {
            toast.error('API error getting Netatmo status, please refresh the page');
        }
    };

    const renderTemperature = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{ status.temperature } °C</div>;
        }
    };

    const renderSetpoint = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{ status.setpoint } °C</div>;
        }
    };

    const renderMode = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{ status.mode }</div>;
        }
    };

    const renderNetatmoChart = () => {
        return (
            <NetatmoChart />
        );
    };

	return (
			<div className="right_col" role="main">
				<header className="page-heading device-page-heading">
					<div>
						<p className="eyebrow">CONNECTED DEVICE</p>
						<h1>Netatmo</h1>
					</div>
				</header>

				<div className="page-title">
					<div className="row top_tiles">
						<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div className="tile-stats">
								<h3>Temperature</h3>
								<div className="icon">
									<FontAwesomeIcon icon={faThermometerHalf} size="3x" />
								</div>
								{renderTemperature()}
							</div>
						</div>
						<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div className="tile-stats">
								<h3>Setpoint</h3>
								<div className="icon">
									<FontAwesomeIcon icon={faHandPointUp} size="3x" />
								</div>
								{renderSetpoint()}
							</div>
						</div>
						<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
							<div className="tile-stats">
								<h3>Mode</h3>
								<div className="icon">
									<FontAwesomeIcon icon={faHome} size="3x" />
								</div>
								{renderMode()}
							</div>
						</div>
					</div>
				</div>

				<div className="clearfix"></div>

				<section className="x_panel" aria-labelledby="netatmo-control-title">
					<div className="x_title">
						<h2 id="netatmo-control-title">Thermostat control</h2>
					</div>
					<div className="x_content">
						<SubmitNetatmoData
							mode={status === "NA" ? null : status.mode}
							setpoint={status === "NA" ? null : status.setpoint}
							onUpdated={getStatus}
						/>
					</div>
				</section>

				<section className="x_panel" aria-labelledby="netatmo-history-title">
					<div className="x_title">
						<h2 id="netatmo-history-title">Temperature history</h2>
					</div>
					<div className="x_content">
						{renderNetatmoChart()}
					</div>
				</section>
			</div>
		);
};

export default Netatmo;
